//按需加载路由
// var HomePage = () => import("@/pages/home"); //首页
var Register = () => import("@/pages/user/register"); //注册
var TicketSearch = () => import("@/pages/ticketbook/ticketsearch"); //航班搜索
var DateTime = () => import("@/pages/ticketbook/datetime"); //价格日历
var CitySelecte = () => import("@/pages/ticketbook/city"); //城市选择
var TicketList = () => import("@/pages/ticketbook/ticketlist"); //航班列表
var ChooseCabin = () => import("@/pages/ticketbook/choosecabin"); //仓位选择
var FillOrder = () => import("@/pages/order/fillorder"); //订单填写
var payOrder = () => import("@/pages/order/paydesk"); //微信收银台
// var addPassenger = () => import("@/pages/passenger/passengerform"); //添加旅客
// var selectPassenger = () => import("@/pages/passenger/selectpassenger"); //选择旅客

var orderList = () => import("@/pages/order/orderlist"); //订单列表
var orderDetail = () => import("@/pages/order/orderdetail"); //订单详情
var applyRefoundDetail = () => import("@/pages/order/applyrefounddetail"); //退款订单详情
//须知规则
var baggageRule = () => import("@/pages/inforule/baggagerule"); //行李规则
var carryGoodsRule = () => import("@/pages/inforule/carrygoods"); //锂电池规定
var dangerGoodsRule = () => import("@/pages/inforule/dangergoodsrule"); //危险品运输规定
var insuranceRule = () => import("@/pages/inforule/insurancerule"); //保险购买规定
var nonvoluntaryRule = () =>
  // import("@/pages/inforule/nonvoluntaryrule"); //非自愿退票规定
  import("@/pages/inforule/nonvoluntaryrule1"); //非自愿退票规定
var specialPassengerRule = () =>
  import("@/pages/inforule/specialpassengerrule"); //特殊旅客运输规定
var transportPassengerRule = () =>
  import("@/pages/inforule/transportpassengerrule"); //运输旅客指南
var transportRule = () => import("@/pages/inforule/transportrule"); //运输总条件

//值机选座
// var CheckSeat = () => import("@/pages/weixinH5/checkseat"); //值机选座
// var CheckOrderList = () => import("@/pages/weixinH5/checkorderlist"); //值机选座订单列表
// var CheckResult = () => import("@/pages/weixinH5/checkresult"); //值机结果
// var eboardingPass = () => import("@/pages/weixinH5/eboardingpass"); //电子登机牌
// var CheckSearch = () => import("@/pages/weixinH5/checksearch"); //值机搜索

//邮寄行程单
var itinerarypost = () =>
  import("@/pages/weixinH5/itinerarymailing/itinerarypost"); //邮寄行程单申请
var itinerarypay = () =>
  import("@/pages/weixinH5/itinerarymailing/itinerarypay"); //邮费支付
var itinerarylist = () =>
  import("@/pages/weixinH5/itinerarymailing/itinerarylist"); //行程单状态列表
var myorder = () => import("@/pages/weixinH5/myorder/myorder"); //我的订单
var xproductOrderList = () =>
  import("@/pages/order/xproductOrderList/xproductOrderList"); //辅营订单

//静态页面
var losttelmsg = () => import("@/pages/inforule/losttelmsg"); //失物招领
var ticketcounter = () => import("@/pages/inforule/ticketcounter"); //值机柜台
var safeExplain = () => import("@/pages/inforule/safeExplain"); //航意险说明
var allClause = () => import("@/pages/inforule/allClause"); //各项条款
var agentProductsInfo = () => import("@/pages/inforule/agentProductsInfo"); //代理商产品
var individualProductsNotice = () =>
  import("@/pages/inforule/individualProductsNotice"); //代理商公告
//个人中心
// var personalcenter = () => import("@/pages/user/personalcenter"); //个人中心首页
// var myuseroption = () => import("@/pages/user/myuseroption"); //个人中心设置页
// var myidcardlist = () => import("@/pages/user/myidcardlist"); //个人中心我的证件
// var addmycard = () => import("@/pages/user/addmycard"); //个人中心添加证件
// var modifyphonenum = () => import("@/pages/user/modifyphonenum"); //个人中心修改手机号

//二维码推广
var staffLogin = () => import("@/pages/weixinH5/qrcodepromotion/stafflogin"); //员工登录
var staffShowMsg = () =>
  import("@/pages/weixinH5/qrcodepromotion/staffshowmsg"); //员工推广二维码
var staffQrcode = () => import("@/pages/weixinH5/qrcodepromotion/staffqrcode"); //员工推广二维码

//X舱活动
// var XCabinHome = () => import("@/pages/activity/Xcabinpage/Xcabinhome"); //x舱活动首页

// var XcabinList = () => import("@/pages/activity/Xcabinpage/Xcabinlist"); // x舱选择航班

// var Xmyapply = () => import("@/pages/activity/Xcabinpage/Xmyapply"); // x舱申请列表

// var XwinningList = () => import("@/pages/activity/Xcabinpage/XwinningList"); // x舱中奖列表

//自助服务相关项
var flightInfoSearch = () => import("@/pages/selfservice/flightInfoSearch"); //航班动态查询
var flightInfoResult = () => import("@/pages/selfservice/flightInfoResult"); //航班动态结果
var checkTicket = () => import("@/pages/selfservice/checkTicket"); //客票验真
// var applyCertify = () =>
//   import("@/pages/weixinH5/wrongFlightCertify/applyCertify");
//航变通知服务
var VerficalInfo = () => import("@/pages/weixinH5/flightChange/verficalinfo"); //航班通知设置
var VerSuccess = () => import("@/pages/weixinH5/flightChange/success"); //结果页
//美团酒店
// var hotelIndex = () => import("@/pages/hotel/hotelIndex"); // 酒店首页
// // 酒店
// var hotelList = () => import("@/pages/hotel/hotelList"); // 酒店列表页
// var hotelDetail = () => import("@/pages/hotel/hotelDetail"); // 酒店详情页
// var hotelIntroduce = () => import("@/pages/hotel/hotelIntroduce"); // 酒店介绍
// var hotelAlbum = () => import("@/pages/hotel/hotelAlbum"); // 酒店相册
// var CancelHotelRoom = () => import("@/pages/hotel/cancelHotelRoom"); //房间退订
// var HotelOrderDetail = () => import("@/pages/hotel/hotelOrderDetail"); //酒店订单详情
// var RefundHotelDetail = () => import("@/pages/hotel/refundHotelDetail"); //酒店退订退款详情
// var HotelOrderList = () => import("@/pages/hotel/hotelOrderList"); //酒店订单列表
// var FillHotelOrder = () => import("@/pages/hotel/fillHotelOrder"); //填写酒店订单
// var hotelCity = () => import("@/pages/hotel/hotelCity"); // 酒店城市列表
// var hotelSelectArea = () => import("@/pages/hotel/selectArea"); // 酒店筛选区域
//景区
var scenicList = () => import("@/pages/inforule/scenicList"); // 景区列表
var scenicDetail = () => import("@/pages/inforule/scenicDetail"); // 景区详情

// 呼叫中心链接支付
var callcenterPay = () => import("@/pages/order/callcenterpay"); // 呼叫中心链接支付
var callcenterInsPay = () => import("@/pages/order/callcenterinspay"); //呼叫保险支付
var insDelayrule = () => import("@/pages/inforule/insdelayrule");
var insDelayrule2 = () => import("@/pages/inforule/insdelayrule2");
var callcenterlugpay = () => import("@/pages/order/callcenterlugpay"); // 呼叫中心行李链接支付
// 机+x
// 餐食
// var food = () => import("@/pages/ticketbook/food"); // 美食详情
var beforeChoice = () => import("@/pages/xproduct/beforechoice"); // 增值产品确认前一页
var selectSeat = () => import("@/pages/xproduct/selectseat"); // 增值产品确认前一页
var selectLuggage = () => import("@/pages/xproduct/selectluggage"); // 选择行李页面
var exProduct = () => import("@/pages/ticketbook/exProduct"); // 机+x产品
// 行李
var luggageOrder = () => import("@/pages/order/luggageorder"); // 行李订单
var luggageRefund = () => import("@/pages/order/luggagerefund"); // 行李退单
import("@/pages/inforule/insdelayrule");
var callcenterrecpay = () => import("@/pages/order/callcenterrecpay");
var mealpay = () => import("@/pages/order/mealpay");//付费餐食支付wzz
var loungepay = () => import("@/pages/order/loungepay");//休息室支付wzz
// 预付款行李模块
// 首页
// var luggageIndex = () => import("@/pages/luggage/index"); // 行李首页
// var payFor = () => import("@/pages/luggage/payfor"); // 逾重行李购买
// var payDetail = () => import("@/pages/luggage/paydetail"); // 逾重行李购买详情
// var luggageList = () => import("@/pages/luggage/orderlist"); // 逾重行李订单列表
// var luggageDetail = () => import("@/pages/luggage/orderdetail"); // 逾重行李订单列表

// 改期
var changeDate = () => import("@/pages/reform/changedate"); // 机票改期
var changeList = () => import("@/pages/reform/changeList"); // 改期机票搜索列表
var changeFillOrder = () => import("@/pages/reform/fillorder"); //改期订单填写
var childchangelist = () => import("@/pages/reform/childchangelist"); // 改期儿童仓位列表
var submitChangeSuccess = () => import("@/pages/reform/submitChangeSuccess"); // 改期儿童仓位列表
// 退票
var refundTicket = () => import("@/pages/reform/refundTicket"); // 退机票
var refundfaredetail = () => import("@/pages/reform/refundfaredetail"); // 退机票费用明细
var submitRefundSuccess = () => import("@/pages/reform/submitRefundSuccess"); // 申请退票成功页
var luggageIndex = () => import("@/pages/luggage/index"); // 行李首页
var payFor = () => import("@/pages/luggage/payfor"); // 逾重行李购买
var payDetail = () => import("@/pages/luggage/paydetail"); // 逾重行李购买详情
var luggageList = () => import("@/pages/luggage/orderlist"); // 逾重行李订单列表
var luggageDetail = () => import("@/pages/luggage/luggageDetail"); // 逾重行李订单详情

var gomini = () => import("@/pages/gomini"); //首页

const beforeArr = [
//   {
//     path: "/",
//     redirect: "/serviceHall"
//   },
//   {
//     path: "/home",
//     name: "home",
//     component: HomePage,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
  {
    path: "/gomini",
    name: "gomini",
    component: gomini,
    meta: {
      requiresAuth: false,
      title: "gomini"
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      requiresAuth: false,
      title: "会员注册"
    }
  },
  {
    path: "/ticketsearch",
    name: "ticketsearch",
    component: TicketSearch,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/datetime",
    name: "datetime",
    component: DateTime,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/city",
    name: "city",
    component: CitySelecte,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/ticketlist",
    name: "ticketlist",
    component: TicketList,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/choosecabin",
    name: "choosecabin",
    component: ChooseCabin,
    meta: {
      requiresAuth: false,
      title: "选择舱位"
    }
  },
//   {
//     path: "/checkseat",
//     name: "checkseat",
//     component: CheckSeat,
//     meta: {
//       requiresAuth: false,
//       title: "选择座位"
//     }
//   },
  {
    path: "/orderlist",
    name: "orderlist",
    component: orderList,
    meta: {
      requiresAuth: true,
      title: "长龙航空"
    }
  },
  {
    path: "/orderdetail",
    name: "orderdetail",
    component: orderDetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/itinerarypost",
    name: "itinerarypost",
    component: itinerarypost,
    meta: {
      requiresAuth: true,
      title: "邮寄行程单"
    }
  },
  {
    path: "/itinerarypay",
    name: "itinerarypay",
    component: itinerarypay,
    meta: {
      requiresAuth: false,
      title: "邮寄行程单"
    }
  },
  {
    path: "/itinerarylist",
    name: "itinerarylist",
    component: itinerarylist,
    meta: {
      requiresAuth: true,
      title: "申请状态"
    }
  },
  {
    path: "/baggagerule",
    name: "baggagerule",
    component: baggageRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/carrygoods",
    name: "carrygoods",
    component: carryGoodsRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/dangergoodsrule",
    name: "dangergoodsrule",
    component: dangerGoodsRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/insurancerule",
    name: "insurancerule",
    component: insuranceRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/nonvoluntaryrule1",
    name: "nonvoluntaryrule",
    component: nonvoluntaryRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/specialpassengerrule",
    name: "specialpassengerrule",
    component: specialPassengerRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/transportpassengerrule",
    name: "transportpassengerrule",
    component: transportPassengerRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/transportrule",
    name: "transportrule",
    component: transportRule,
    meta: {
      keepAlive: true,
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/myorder",
    name: "myorder",
    component: myorder,
    meta: {
      requiresAuth: true,
      title: "我的订单"
    }
  },
  {
    path: "/xproductOrderList",
    name: "xproductOrderList",
    component: xproductOrderList,
    meta: {
      requiresAuth: true,
      title: "我的订单"
    }
  },
  {
    path: "/losttelmsg",
    name: "losttelmsg",
    component: losttelmsg,
    meta: {
      requiresAuth: false,
      title: "失物招领电话"
    }
  },
  {
    path: "/ticketcounter",
    name: "ticketcounter",
    component: ticketcounter,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
//   {
//     path: "/personalcenters",
//     name: "personalcenter",
//     component: personalcenter,
//     meta: {
//       requiresAuth: true,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/myuseroption",
//     name: "myuseroption",
//     component: myuseroption,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/myidcardlist",
//     name: "myidcardlist",
//     component: myidcardlist,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/addmycard",
//     name: "addmycard",
//     component: addmycard,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/modifyphonenum",
//     name: "modifyphonenum",
//     component: modifyphonenum,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
  {
    path: "/stafflogin",
    name: "stafflogin",
    component: staffLogin,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/staffqrcode",
    name: "staffqrcode",
    component: staffQrcode,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/staffshowmsg",
    name: "staffshowmsg",
    component: staffShowMsg,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
//   {
//     path: "/xcabinhome",
//     name: "xcabinhome",
//     component: XCabinHome,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/xcabinlist",
//     name: "xcabinlist",
//     component: XcabinList,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/xmyapply",
//     name: "xmyapply",
//     component: Xmyapply,
//     meta: {
//       requiresAuth: false,
//       title: "申请列表"
//     }
//   },
//   {
//     path: "/xwinningList",
//     name: "xwinningList",
//     component: XwinningList,
//     meta: {
//       requiresAuth: false,
//       title: "中奖列表"
//     }
//   },
  {
    path: "/flightInfoSearch",
    name: "flightInfoSearch",
    component: flightInfoSearch,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  //   {
  //     path: "/applyCertify",
  //     name: "applyCertify",
  //     component: applyCertify,
  //     meta: {
  //       requiresAuth: false,
  //       title: "长龙航空"
  //     }
  //   },
  {
    path: "/flightInfoResult",
    name: "flightInfoResult",
    component: flightInfoResult,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/checkTicket",
    name: "checkTicket",
    component: checkTicket,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/verficalinfo",
    name: "verficalinfo",
    component: VerficalInfo,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/versuccess",
    name: "versuccess",
    component: VerSuccess,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/safeexplain",
    name: "safeexplain",
    component: safeExplain,
    meta: {
      requiresAuth: false,
      title: "航意险"
    }
  },
  {
    path: "/allclause",
    name: "allclause",
    component: allClause,
    meta: {
      requiresAuth: false,
      title: "服务条款"
    }
  },
  {
    path: "/agentProductsInfo",
    name: "agentProductsInfo",
    component: agentProductsInfo,
    meta: {
      requiresAuth: false,
      title: "代理商产品"
    }
  },
  {
    path: "/individualProductsNotice",
    name: "individualProductsNotice",
    component: individualProductsNotice,
    meta: {
      requiresAuth: false,
      title: "散客产品公告"
    }
  },
//   {
//     path: "/hotelindex",
//     name: "hotelindex",
//     component: hotelIndex,
//     meta: {
//       requiresAuth: false,
//       title: "酒店首页"
//     }
//   },
//   {
//     path: "/hotelcity",
//     name: "hotelcity",
//     component: hotelCity,
//     meta: {
//       requiresAuth: false,
//       title: "城市列表"
//     }
//   },
//   {
//     path: "/hotellist",
//     name: "hotellist",
//     component: hotelList,
//     meta: {
//       requiresAuth: false,
//       title: "酒店列表"
//     }
//   },
//   {
//     path: "/hoteldetail/:id",
//     name: "hoteldetail",
//     component: hotelDetail,
//     meta: {
//       requiresAuth: false,
//       title: "酒店详情"
//     }
//   },
//   {
//     path: "/hotelintroduce/:id",
//     name: "hotelintroduce",
//     component: hotelIntroduce,
//     meta: {
//       requiresAuth: false,
//       title: "酒店详情"
//     }
//   },
//   {
//     path: "/hotelalbum/:id",
//     name: "hotelalbum",
//     component: hotelAlbum,
//     meta: {
//       requiresAuth: false,
//       title: "酒店相册"
//     }
//   },
//   {
//     path: "/cancelroom",
//     name: "cancelroom",
//     component: CancelHotelRoom,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/hotelorderdetail",
//     name: "hotelorderdetail",
//     component: HotelOrderDetail,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/refundhoteldetail",
//     name: "refundhoteldetail",
//     component: RefundHotelDetail,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/hotelorderlist",
//     name: "hotelorderlist",
//     component: HotelOrderList,
//     meta: {
//       requiresAuth: true,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/hotelselectarea",
//     name: "hotelselectarea",
//     component: hotelSelectArea,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/fillhotelorder/:id",
//     name: "fillhotelorder",
//     component: FillHotelOrder,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
  {
    path: "/scenicspot",
    name: "scenicspot",
    component: scenicList,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/scenicdetail",
    name: "scenicdetail",
    component: scenicDetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/callcenterpay",
    name: "callcenterpay",
    component: callcenterPay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/callcenterinspay",
    name: "callcenterinspay",
    component: callcenterInsPay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/insdelayrule",
    name: "insdelayrule",
    component: insDelayrule,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/insdelayrule2",
    name: "insdelayrule2",
    component: insDelayrule2,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
//   {
//     path: "/food",
//     name: "food",
//     component: food,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
  {
    path: "/luggageindex",
    name: "luggageindex",
    component: luggageIndex,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/luggageorder",
    name: "luggageorder",
    component: luggageOrder,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/luggagerefund",
    name: "luggagerefund",
    component: luggageRefund,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/payfor",
    name: "payfor",
    component: payFor,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/beforechoice",
    name: "beforechoice",
    component: beforeChoice,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/paydetail",
    name: "paydetail",
    component: payDetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/selectseat",
    name: "selectseat",
    component: selectSeat,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/luggagelist",
    name: "luggagelist",
    component: luggageList,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/selectluggage",
    name: "selectluggage",
    component: selectLuggage,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/luggagedetail",
    name: "luggagedetail",
    component: luggageDetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/changedate",
    name: "changedate",
    component: changeDate,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/refundticket",
    name: "refundticket",
    component: refundTicket,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/refundfaredetail",
    name: "refundfaredetail",
    component: refundfaredetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/submitRefundSuccess",
    name: "submitRefundSuccess",
    component: submitRefundSuccess,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/changelist",
    name: "changelist",
    component: changeList,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/childchangelist",
    name: "childchangelist",
    component: childchangelist,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/submitChangeSuccess",
    name: "submitChangeSuccess",
    component: submitChangeSuccess,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/changefillorder",
    name: "changefillorder",
    component: changeFillOrder,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/refounddetail",
    name: "refounddetail",
    component: applyRefoundDetail,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/fillorder",
    name: "fillorder",
    component: FillOrder,
    meta: {
      requiresAuth: false,
      title: "订单填写"
    }
  },
  {
    path: "/payorder",
    name: "payorder",
    component: payOrder,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
//   {
//     path: "/addpassenger",
//     name: "addpassenger",
//     component: addPassenger,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/selectpassenger",
//     name: "selectpassenger",
//     component: selectPassenger,
//     meta: {
//       requiresAuth: false,
//       title: "长龙航空"
//     }
//   },
//   {
//     path: "/checksearch",
//     name: "checksearch",
//     component: CheckSearch,
//     meta: {
//       requiresAuth: false,
//       title: "在线选座"
//     }
//   },
//   {
//     path: "/checkorderlist",
//     name: "checkorderlist",
//     component: CheckOrderList,
//     meta: {
//       requiresAuth: false,
//       title: "行程列表"
//     }
//   },
//   {
//     path: "/checkresult",
//     name: "checkresult",
//     component: CheckResult,
//     meta: {
//       requiresAuth: false,
//       title: "选座结果"
//     }
//   },
//   {
//     path: "/eboardingpass",
//     name: "eboardingpass",
//     component: eboardingPass,
//     meta: {
//       requiresAuth: false,
//       title: "座位信息"
//     }
//   },
  {
    path: "/callcenterrecpay",
    name: "/callcenterrecpay",
    component: callcenterrecpay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/mealpay",
    name: "/mealpay",
    component: mealpay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/loungepay",
    name: "/loungepay",
    component: loungepay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/exproduct",
    name: "/exproduct",
    component: exProduct,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
  {
    path: "/callcenterlugpay",
    name: "callcenterlugpay",
    component: callcenterlugpay,
    meta: {
      requiresAuth: false,
      title: "长龙航空"
    }
  },
];
export default beforeArr;



// WEBPACK FOOTER //
// ./src/router/modules/beforeOptimize.js